import React, { useState, useEffect} from 'react';
import KindergartenCard from '../KindergartenCard/KindergartenCard';
import SearchFilterSection from '../SearchFilterSection/SearchFilterSection';
import ResultsSection from '../ResultsSection/ResultsSection';
import MapPlaceholder from '../../../../../components/MapPlaceholder/MapPlaceholder';
import LoadMoreButton from '../LoadMoreButton/LoadMoreButton';
import KindergartensTable from '../KindergartensTable/KindergartensTable';

import './KindergartensPage.css';

import { getKindergartensList } from '../../actions';
import { getFilterObj } from '../../data/filters';

const SELECTED_KG_PERM = 'cabinetkgselected';

const KindergartensPage = ({ showFilters = false, isListView = false, isChecked = false, listChecked = [], onCheck, uncheckAll, isFixed=false }) => {

  const sel_pm_info = localStorage.getItem(SELECTED_KG_PERM);

  const [filtersExpanded, setFiltersExpanded] = useState(showFilters);
  const [kindergartensData, setData] = useState([]);
  const [period, setPeriod] = useState("all");
  const [filters, setFilters] = useState(getFilterObj);
  const [viewcount, setViewCount] = useState(0);
  const [search, setSearch] = useState({ search: "", near: "", searchBy: "number", addressDistr: "", addressStr: "", addressBuilding: "", addressCorpus: ""});
  const [viewtables, setShowTables] = useState(isListView);
  const [selectedKg, setSelectedKg] = useState( sel_pm_info && JSON.parse(sel_pm_info) || []);
  

  const onCheck_ = (data)=>{

    //if(data) localStorage.setItem(SELECTED_KG_PERM, JSON.stringify());

    onCheck(data);
  }


  const getData = async () => {

    const result = await getKindergartensList({period, near_address: search.near, search: search.search, search_by: search.searchBy, filters});

    setViewCount(listChecked.length > 6 ? listChecked.length : 6);

    setData(result);

    if(listChecked.length > 0) getSelectedKgInfo();
  }

  const addList = () => {
    setViewCount(viewcount + 6);
  }


  const getSelectedKgInfo = async () => {
    const selectedArchId = selectedKg.map(k=>k._id);
    
    const needInfoKgId = listChecked.filter(i=>!selectedArchId.includes(i));

    if(needInfoKgId.length < 1) return;
    
    const result = await getKindergartensList({filters: { 'id_kg': needInfoKgId }});

    const resArr = [...selectedKg, ...result]; 

    setSelectedKg( resArr );


  }


  useEffect(()=>{getData()}, [period, filters, search]);

  useEffect(()=>{localStorage.setItem(SELECTED_KG_PERM, JSON.stringify(listChecked))}, [ listChecked ]);

  //useEffect(()=>{getSelectedKgInfo()}, [period, filters,search]);


  const combUniqKg = (arrKg1, arrKg2) => {

    const combinedArray = [...arrKg1];

    const idsArr = combinedArray.map(g=>g._id);

    arrKg2.forEach(t => {

      if(!idsArr.includes(t._id)) combinedArray.push(t);
      
    });

    return combinedArray;

  }


  
  const toggleFilters = () => {
    setFiltersExpanded(!filtersExpanded);
  };

  const combKgList = listChecked.length > 0 ? combUniqKg(kindergartensData, selectedKg.filter(sv=>listChecked.includes(sv._id))) : kindergartensData;
  
  const combKgSlice = combKgList.sort((a,b)=>a.number == b.number ? 0 : a.number > b.number ? 1 : -1).slice(0, viewcount);

  return (
    <div className={isListView ? 'list-view' : ''}>
      {!isListView && <MapPlaceholder kglist={combKgSlice}/>}
      
      <div className="container my-5">
        {!isListView && <h1 className="mb-4">Усі дитячі садочки Києва</h1>}



       <SearchFilterSection 
          isExpanded={filtersExpanded} 
          onToggleFilters={toggleFilters}
          searchFilter={setSearch}
          search={search}
          setFilters={setFilters}
          filters={filters}
        />

        <ResultsSection 
          totalCount={kindergartensData.length} 
          displayedCount={kindergartensData.length < viewcount ? kindergartensData.length : viewcount} 
          isListView={viewtables}
          onlyList={isListView}
          setListView={setShowTables}
          Checked={isChecked ? listChecked.length : 0}     
        />

        {viewtables ? <KindergartensTable 
          tableData={combKgList.sort((a,b)=>{
            if(listChecked.includes(a._id) !== listChecked.includes(b._id)) {
              return listChecked.includes(a._id) > listChecked.includes(b._id) ? -1: 1 ;
            }
            return a.number == b.number ? 0 : a.number > b.number ? 1 : -1;
            }
          ) 
            .slice(0, viewcount)
          }
          isChecked={isChecked}
          listChecked={listChecked}
          onCheck={onCheck_}
          uncheckAll={uncheckAll}
          isFixed={isFixed}
          />
            : 
            <div className="row g-4">
          {combKgSlice.map(kindergarten => (
            <div key={kindergarten.id} className="col-md-6 col-lg-4">
              <KindergartenCard 
                kindergarten={kindergarten} 
                highlighted={kindergarten.highlighted}
              />
            </div>
          ))}
        </div>}

        { (kindergartensData.length > viewcount) && <LoadMoreButton onClick={()=>addList()}/>}
      </div>
    </div>
  );
};

export default KindergartensPage;